<template>
  <div>
    <div class="back"><span @click="$router.back(-1)"> ＜返回 </span></div>
    <div class="detail">
      <div class="uppdf">
        <div style="display: flex;align-items: center;text-align: center;margin-bottom: 20px;flex-wrap: wrap">
          <el-upload style="width: 50%"
                     class="upload-demo" multiple
                     :http-request="img_upload" :before-upload="upload_check" accept="image/*"  :show-file-list="false">
            <el-button size="module" type="primary">图片上传</el-button>
          </el-upload>
          <el-upload style="width: 50%"
              class="upload-demo"
              :http-request="pdf_upload" accept=".pdf"  :show-file-list="false">
            <el-button size="module" type="primary">pdf上传</el-button>
          </el-upload>
          <div style="width: 50%;margin-top: 20px;">
            <el-checkbox v-model="all" @change="check_all">全选</el-checkbox>
          </div>
          <div style="width: 50%;margin-top: 20px;">
            <el-popconfirm title="确定删除？" @confirm="del_all()">
              <el-button slot="reference" type="text">批量删除</el-button>
            </el-popconfirm>
          </div>
        </div>
        <div class="">
          <template v-for="(val,key) in post.content">
            <div :key="key" class="box">
              <div style="display: flex;align-items: center;" @click="middle(key)">
                <el-checkbox style="position:absolute;top: 3px;left: 5px;" v-model="val.is_choose"
                             v-if="is_all" @change="checkbox($event,key)"></el-checkbox>
                <img :src="val.url" style="width: 80px;height:110px;margin: 10px 30px;">
                <div v-if="val.title">{{val.title}}</div>
                <div v-else>目录名称</div>
              </div>
              <div class="done" >
                <span class="iconfont icon-xiangshangjiantou" @click.stop="top_move(key)"></span>
                <span class="iconfont icon-xiangxiajiantou" @click.stop="down_move(key)"></span>
                <span style="font-size: 13px;" @click.stop="title(key)">目录名称</span>
                <span style="font-size: 13px;">
                  <el-upload style="display: inline-block"
                             :http-request="img_put"
                             :data="key"
                             multiple
                             :before-upload="upload_check" accept="image/*"
                             :show-file-list="false">
                    插入图片
                  </el-upload>
                </span>
                <span style="padding: 0;border: 0;">
                <el-popconfirm title="确认删除？" @confirm="del(key)">
                <el-button @click.stop  size="small" slot="reference"
                           style="border: 0;padding: 0;color: #409eff;">删除
                </el-button>
                </el-popconfirm>
                </span>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="view">
<!--        <el-carousel height="800px" :autoplay="false" arrow="always" indicator-position="none">
          <el-carousel-item v-for="(val,key) in post.content" :key="key"
                            style="display: flex;flex-direction: column;justify-content: center">
            <div class="box" @click="edit(key)" >
              <el-tooltip :content="val.title" placement="top" effect="light">
                <img :src="val.url" :class="val.class">
              </el-tooltip>
              <div class="done" >
                <span class="iconfont icon-xiangzuojiantou" @click.stop="top_move(key)"></span>
                <span class="iconfont icon-xiangyoujiantou" @click.stop="down_move(key)"></span>
                <span style="font-size: 13px;" @click.stop="title(key)">目录名称</span>
                <span style="padding: 0;border: 0;">
              <el-popconfirm title="确认删除？" @confirm="del(key)">
              <el-button @click.stop  size="small" slot="reference"
                         style="border: 0;padding: 0;color: #409eff;">删除
              </el-button>
              </el-popconfirm>
            </span>
              </div>
              <template v-for="(vals,k) in val.item">
                <div :key="k" :style="{'left':vals.x_axis+'%','top':vals.y_axis+'%','position': 'absolute',}"
                     class="point">{{vals
                    .title}}</div>
              </template>
            </div>
            <div style="text-align: center;position:relative;">
              <span style="margin: 0 150px 0 180px;">{{key+1}}</span>
              <span style="font-size: 14px;">{{'(共'+ post.content.length+'页)'}}</span>
            </div>
          </el-carousel-item>
        </el-carousel>-->
        <template v-if="post.content.length>0" >
          <div style="color: #333;font-size: 20px;padding: 5px 0;"
               v-if="post.content[key].title">{{post.content[key].title}}</div>
          <div style="color: #333;font-size: 20px;padding: 5px 0;" v-else>目录名称</div>
        <div class="box" >
          <img :src="post.content[key].url" @click="edit(key)">
<!--          <div class="done" >
            <span class="iconfont icon-xiangshangjiantou" @click.stop="top_move(key)"></span>
            <span class="iconfont icon-xiangxiajiantou" @click.stop="down_move(key)"></span>
            <span style="font-size: 13px;" @click.stop="title(key)">目录名称</span>
            <span style="padding: 0;border: 0;">
              <el-popconfirm title="确认删除？" @confirm="del(key)">
              <el-button @click.stop  size="small" slot="reference"
                         style="border: 0;padding: 0;color: #409eff;">删除
              </el-button>
              </el-popconfirm>
            </span>
          </div>-->
          <template v-if="post.content.length>0">
          <template v-for="(vals,k) in post.content[key].item" >
            <div :key="k" :style="{'left':vals.x_axis+'%','top':vals.y_axis+'%','position': 'absolute',}"
                 class="point">{{vals.is_show==1 ? vals.title : ''}}</div>
          </template>
          </template>
        </div>
        </template>
      </div>
      <div class="create">
        <el-form label-width="80px" :model="post" ref="post" :rules="rules">
          <el-form-item label="标题" prop="title">
            <el-input v-model="post.title" placeholder="标题" style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item label="封面" prop="cover">
            <el-upload style="width: 120px;height: 160px;border: 1px solid #DCDFE6;border-radius: 5px;"
                       class="upload-demo"
                       accept="image/*"
                       :show-file-list="false"
                       :on-change='changeUpload'>
              <i class="el-icon-upload" style="width: 120px;height: 160px;font-size: 60px;line-height: 160px;text-align: center;color: #409eff" v-if="!post.cover"></i>
              <img :src="post.cover" style="width: 100%;height: 100%;border-radius: 5px;object-fit: contain" v-if="post.cover">
            </el-upload>
            <el-tag type="danger">宽高比例 3:4</el-tag>
          </el-form-item>
          <el-form-item label="手机号" prop="">
            <el-input v-model="post.phone" placeholder="手机号" class="w-200"></el-input>
          </el-form-item>
          <el-form-item label="禁止联系" prop="is_stop_contact">
            <el-switch  v-model="post.is_stop_contact"
                        active-value="1"
                        inactive-value="0"></el-switch>
          </el-form-item>
          <el-form-item label="计费方式" prop="">
            <template>
              <el-radio v-model="post.look_type" label="1">次数</el-radio>
              <el-radio v-model="post.look_type" label="2">时间</el-radio>
            </template>
          </el-form-item>
          <el-form-item label="分配次数" v-if="post.look_type==1 && !post.id">
            <el-input v-model="post.system_num" placeholder="分配次数" class="w-200"></el-input>
          </el-form-item>
          <template v-if="post.look_type==2">
            <el-date-picker
                v-model="date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd">
            </el-date-picker>
          </template>
          <!--          <el-form-item label="绑定微信" >
            <el-select v-model="post.uid" filterable remote clearable :remote-method="user_search"
                       :loading="is_loading" placeholder="请搜索昵称">
              <el-option v-for="(val,key) in list" :key="key" :value="val.id" :label="val.nickname">
                <div class="o-user">
                  <div class="o-avatarurl" :style="{ backgroundImage:'url('+val.avatarurl+')' }"></div>
                  <div class="o-nickname">{{val.nickname}}</div>
                </div>
              </el-option>
            </el-select>
          </el-form-item>-->
          <img v-if="post.wxcode" :src="post.wxcode" alt="" style="margin: 10px 90px;width: 200px;height: 200px;">
          <img v-else :src="this.qrcode" alt="" style="margin: 10px 90px;width: 200px;height: 200px;">
          <el-form-item>
            <el-button type="primary" class="w-150" style="margin: 20px 40px" @click="submit">确认保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <LayerPop title="编辑图片" @close="vue_pop_show_hide" v-if="is_pop">
      <edit :img="post.content[key]" :content="post.content" :index="key"></edit>
    </LayerPop>
    <div class="cut">
      <el-dialog title="图片剪裁" :visible.sync="dialogVisible" append-to-body>
        <div class="cropper-content">
          <div class="cropper" style="text-align:center">
            <vueCropper
                ref="cropper"
                :img="option.img"
                :outputSize="option.size"
                :outputType="option.outputType"
                :info="true"
                :full="option.full"
                :autoCropWidth="option.autoCropWidth"
                :canMove="option.canMove"
                :canMoveBox="option.canMoveBox"
                :original="option.original"
                :autoCrop="option.autoCrop"
                :fixed="option.fixed"
                :fixedNumber="option.fixedNumber"
                :centerBox="option.centerBox"
                :infoTrue="option.infoTrue"
                :fixedBox="option.fixedBox"
            ></vueCropper>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="finish" :loading="loading">确认</el-button>
        </div>
      </el-dialog>
    </div>
    <layer-pop title="批量上传图片" v-if="is_multiple" @close="is_multiple=false">
      <multiple v-model="imglist" :list="imglist" :imglist="imglist" @submit="multiple_submit"></multiple>
    </layer-pop>
    <layer-pop title="选择图片" @close="is_img=false" v-if="is_img">
      <upload-img @submit="img_choose"></upload-img>
    </layer-pop>
  </div>
</template>

<script>
// import Nav from "@/components/nav";
// import VueUpload from "@/components/upload/upload";
import LayerPop from "@/components/layer-pop";
import edit from "@/components/ebook/edit";
import VueCropper from 'vue-cropper'
import Multiple from "@/components/multiple.vue";
import UploadImg from "@/components/upload/upload-img.vue";
export default {
  name: "detail",
  components:{UploadImg, Multiple, LayerPop,edit,VueCropper},
  data(){
    // const is_phone = (rule, value, callback) => {
    //   if (!value) {
    //     callback(new Error('请填写'))
    //   } else {
    //     // const reg = /^1[3|4|5|6|7|8][0-9]\d{8}$/
    //     // if (reg.test(value)) {
    //       callback()
    //     // } else {
    //     //   return callback(new Error('手机号有误'))
    //     // }
    //   }
    // }
    return{
      msg: 'ebook_detail',
      rules : {
        title : [{required:true, message : '请填写', trigger:'blur'}],
        cover : [{required:true, message : '请上传', trigger:'blur'}],
        // phone : [{required:true,validator:is_phone,trigger: 'blur'}],
      },
      post : {
        title : '',
        cover : '',
        phone:'',
        music:'',
        content:[],
        look_type:'1',
        system_num:'',
        is_stop_contact:'1',
        is_show:1,
      },
      imglist:[],
      is_pop:false,
      qrcode:'https://static.clewm.net/cli/images/nc/qrcode-none-new@2x.png',
      dir:[],
      list:[],
      key:0,
      dialogVisible: false,
      option: {
        img: '', // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 0.8, // 裁剪生成图片的质量
        outputType: 'jpeg', // 裁剪生成图片的格式
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 750, // 默认生成截图框宽度
        autoCropHeight: 1000, // 默认生成截图框高度
        fixedBox: true, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [3, 4], // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      },
      date:'',
      all:false,
      is_all:false,
      is_multiple:false,
      is_img:false,
    }
  },
  mounted:async function() {
    try {
      let query = this.$route.query;
      if (query.id){
        await this.get_one(query.id);
        if (this.post.uid){
          let res_list = await this.$_api.admin('get_for_list', {uid : this.post.uid});
          if (res_list.errcode == 0){
            this.list = res_list.list;
          }
        }
      }
    }catch (e) {
      console.log(e);
    }
  },
  methods:{
    user_search : async function (e){
      try{
        console.log(e);
        this.is_loading = true;
        let res = await this.$_api.admin('get_user_list', {keyword : e});
        this.is_loading = false;
        if (res.errcode == 0){
          this.list = res.list;
        }
      }catch (e){
        console.log(e);
        return false;
      }
    },
    check_all:function (e){
      this.is_all = true;
      if(e){
        this.post.content.map(function (item){
          item.is_choose = true;
        })
      }else{
        this.post.content.map(function (item){
          item.is_choose = false;
        })
      }
    },
    checkbox:function (e,index){
      let that = this;
      this.post.content[index].is_choose = e;
      if(e){
        that.all = true;
        this.post.content.map(function (item){
          if(!item.is_choose){
            that.all = false;
            return;
          }
        });
      }else{
        that.all = false;
      }
    },
    del_all:function (){
      let that = this;
      let content = that.post.content;
      let lenth = that.post.content.length;
      for(let i = lenth-1;i>=0;i--){
        if(content[i].is_choose){
          content.splice(i,1);
        }
      }
      this.post.content = content;
    },
    pdf_upload:async function (e){
      try{
        console.log(e);
        console.log(e.file);
        if (e.file){
          this.$_showLoading('大概需要2-3分钟');
          let res = await this.$_api.pdf_upload(e.file);
          this.$_hideLoading();
          this.$_showToast(res.errmsg,res.style);
          if(res.errcode == 0){
            this.post.content.push.apply(this.post.content,res.data);
          }
        }
      }catch (e){
        console.log(e);
        return false;
      }
    },
    img_upload:async function (e){
      try {
        console.log(e);
        if (e.file){
          this.$_showLoading();
          let res = await this.$_api.upload(e.file,'img','',this.user.uid);
          this.$_hideLoading();
          // this.$_showToast(res.errmsg,res.style);
          let data = {title:'',url:res.url,item:[],audio:'',filename:res.filename,is_choose:false};
          this.imglist.push(data);
          this.is_multiple = true;
        }
      }catch (e) {
        console.log(e);
        this.$_hideLoading();
        this.$_showToast('上传失败，请稍后重试');
        return false;
      }
    },
    img_put:async function (e){
      try {
        console.log(e.data);
        if (e.file){
          this.$_showLoading();
          let res = await this.$_api.upload(e.file,'img',this.dir.join('/'),this.user.uid);
          this.$_hideLoading();
          let data = {title:'',url:res.url,item:[],audio:'',filename:res.filename};
          this.post.content.splice(e.data+1,0,data);
        }
      }catch (e) {
        console.log(e)
      }
    },
    upload_check:function (e){
      let that = this;
      let check_img = new Promise(function (resolve, reject){
          let _url = window.URL || window.webkitURL;
          let image = new Image();
          image.onload = function (){
            //检查比例
            //   if ((image.width / image.height) == (3 / 5)){
            //     that.$_showToastNone('图片宽高比例必须是3:5');
            //     reject();
            //   }
              let size = image.size / 1024 / 1024;
              if (size > 5){
                that.$_showToastNone('最大只能上传5M');
                reject();
              }
            resolve();
          }
          image.src = _url.createObjectURL(e);
      })
      return check_img;
    },
    del:async function (key){
      console.log(key);
      this.post.content.splice(key,1);
    },
    top_move:function (key){
      if(key==0){
        return;
      }
      if(key != 0){
        this.post.content[key] = this.post.content.splice(key-1,1,this.post.content[key])[0];
      }else{
        this.post.content.push(this.post.content.shift());
      }
    },
    down_move:function (key){
      if(key >= this.post.content.length-1){
        return;
      }
      if(key != this.post.content.length-1){
        this.post.content[key] = this.post.content.splice(key+1,1,this.post.content[key])[0];
      }else{
        this.post.content.unshift(this.post.content.splice(key,1)[0])
      }
    },
    title:function (key){
      this.$prompt('请输入目录名称', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ value }) => {
        this.post.content[key].title = value;
        // this.$message({
        //   type: 'success',
        //   message: '提交成功'
        // });
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '取消输入'
        // });
      });
    },
    middle:function (key){
      this.key=key;
    },
    edit:function (key){
      console.log(key);
      this.is_pop = true;
      this.key=key;
    },
    submit:async function (){
      try {
        let that = this;
        this.$refs['post'].validate( async function  (check){
          if (check){
            if(that.post.look_type==2) {
              if(that.date){
                that.post['start_time'] = that.date[0];
                that.post['end_time'] = that.date[1];
              }else{
                that.$_showToast('请选择日期','error');
                return;
              }
            }
            let way = that.post['id'] ? 'edit' : 'add';
            that.post['create_id'] = that.user.uid;
            that.post['uid'] = that.user.uid;
            that.$_showLoading();
            let res = await that.$_api.ebook(way, that.post);
            that.$_hideLoading();
            that.$_showToast(res.errmsg,res.style);
            if(res.errcode == 0){
              that.post.qrcode = res.url;
              setTimeout(function (){
                // if(that.user.login_type=='company'){
                //   that.$router.push('company_ebook_list');
                // }else{
                //   that.$router.push('ebook');
                // }
                if(that.post['id']){
                  that.$router.push({path:'/ebook_detail',query:{id:res.data}});
                }else{
                  if(that.user.login_type=='company'){
                    that.$router.push('company_ebook_list');
                  }else{
                    that.$router.push('ebook');
                  }
                }
              },1500)
              // that.$router.push({path:'/ebook_detail',query:{id:res.data}});
            }
          }
        })
      }catch (e) {
        console.log(e);
      }
    },
    get_one:async function(id){
      try {
        let res = await this.$_api.ebook('get_one_for_post', {id : id});
        if (res.errcode == 0){
          console.log(res.post);
          this.post = res.post;
          this.date = res.date;
          // this.content = res.post.content;
        }
      }catch (e) {
        console.log(e);
      }
    },
    changeUpload:async function (e) {
      let file = e;
      const isLt5M = file.size / 1024  < 500
      if (!isLt5M) {
        this.$message.error('上传文件大小不能超过 500KB!')
        return false
      }
      let res = window.URL.createObjectURL(file.raw);
      console.log(res);
      this.fileinfo = file;
      // 上传成功后将图片地址赋值给裁剪框显示图片
      this.$nextTick(() => {
        this.option.img = res;
        this.dialogVisible = true;
      })
    },
    finish() {
      let that = this;
      this.$refs.cropper.getCropBlob(async function (data) {
        console.log(data);
        let res = await that.$_api.upload(data,'img','',that.user.uid);
        that.post.cover = res.url;
        that.dialogVisible = false;
      })
    },
    img_choose:function (e){
      let data = {title:'',url:e.url,item:[],audio:'',filename:e.filename,is_choose:false};
      this.imglist.push(data);
    },
    multiple_submit:function (e){
      let that = this;
      that.post.content = that.post.content.concat(e);
      that.$emit('change',that.post.content);
      that.imglist = [];
      that.is_multiple = false;
    }
  }
}
</script>

<style scoped>
.back{border-bottom: 1px solid #eee;color: #ccc;cursor: pointer;padding: 10px;}
.detail{margin: 20px;display: flex;}
.uppdf{
  box-shadow: 0 0 5px #dcdfe6;
  border-radius: 5px;
  padding: 20px 0;
  width: 360px;
  height: 800px;
  overflow: auto;
}
.view{
  box-shadow: 0 0 5px #dcdfe6;
  border-radius: 5px;
  margin: 0 auto;
  padding: 20px 0;
  color: #999;
  width: 550px;
  height: 800px;
  text-align: center;
}
.create{
  /*border: 1px solid #dcdfe6;*/
  box-shadow: 0 0 5px #dcdfe6;
  border-radius: 5px;
  padding: 20px 10px;
  color: #999;
  width: 350px;
}
.o-user { height: 34px; display: flex; overflow-x: hidden; }
.o-avatarurl { width: 34px; height: 34px; border-radius: 17px; overflow-x: hidden; background: transparent no-repeat center; background-size: cover; }
.o-nickname { flex: 1; padding-left: 10px; }
.box{
  border: 1px dashed #dcdfe6;
  text-align: center;
  margin-bottom: 10px;
  cursor: pointer;
  position: relative;
}
.box  img{width: 100%;}
.box:hover{
  color: #409eff;border: 1px dashed #409eff;
}
.box:hover .done{display: inline-block}

.done{position: absolute;display: none;right:0;top:-15px;height:30px;line-height: 30px;background: #fff;border-radius: 4px;box-shadow: #eee 0 0 2px 1px;
}
.done span{padding: 0 10px;border-right:1px solid #eee;}
.point{
  position:absolute;
  padding:0 12px;
  height: 24px;
  line-height: 24px;
  background:rgba(38,34,33,.7);
  border-radius:20px;
  font-size:12px;
  color:#ffffff;
  z-index:99;
  transform:translateX(8px)translateY(-50%);
}
.point::after{
  left:-12px;
  content:"";
  display:block;
  position:absolute;
  width:8px;
  height:8px;
  border-radius:50%;
  background:rgba(0,0,0,.2);
  top:50%;
  transform:translateY(-50%);
}
.cut{
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  display: none;
}
.cropper-content .cropper {
  width: auto;
  height: 300px;
}
</style>